import React from "react";
import { Navigate } from "react-router-dom";

const StkSriIssued = React.lazy(
  () => import("../../../../../components/stk-sri/components/issued/page"),
);
const StkSriReceived = React.lazy(
  () => import("../../../../../components/stk-sri/components/received/page"),
);

const StkSriEmmitted = React.lazy(
  () => import("../../../../../components/stk-sri/components/emitted/page"),
);
const StkAtsPanel = React.lazy(
  () => import("../../../../../components/stk-sri/components/ats-panel/page"),
);
const StkSriVoided = React.lazy(
  () => import("../../../../../components/stk-sri/components/voided/page"),
);
const SriSyncJobPanel = React.lazy(
  () => import("../../../../../components/sri-sync-job/components/list/page"),
);
const SriCreateInvoice = React.lazy(
  () => import("../../../../../components/stk-sale/components/invoice/page"),
);

export const facturasRoutes = [
  {
    path: "add",
    element: <SriCreateInvoice />,
  },
  {
    path: "issued",
    element: <StkSriIssued />,
  },
  {
    path: "agent",
    element: <SriSyncJobPanel />,
  },
  {
    path: "received",
    element: <StkSriReceived />,
  },
  {
    path: "emitted",
    element: <StkSriEmmitted />,
  },

  {
    path: "voided",
    element: <StkSriVoided />,
  },
  {
    path: "ats",
    element: <StkAtsPanel />,
  },
  {
    path: "",
    element: <Navigate replace to="/sri/invoices/issued" />,
  },
];
